import CompanyModel from '@mm/state/model/CompanyModel';
import { Interpreter } from 'xstate';
import { SignUpFlowEvents } from './signUpMachineEventTypes';

export const enum SIGN_UP_FLOW_STATES_NAME {
  INIT = 'INIT',
  WELCOME = 'WELCOME',
  BILLING = 'BILLING',
  REDIRECT = 'REDIRECT',
  GOAL = 'GOAL',
}

export type SignUpFlowContext = {
  activeStep: number;
  company?: CompanyModel;
  stepOptions: {
    isOtherIndustrySelected: boolean;
  };
};

export type SignUpFlowStatesSchema = {
  states: {
    [SIGN_UP_FLOW_STATES_NAME.INIT]: {};
    [SIGN_UP_FLOW_STATES_NAME.WELCOME]: {};
    [SIGN_UP_FLOW_STATES_NAME.BILLING]: {};
    [SIGN_UP_FLOW_STATES_NAME.REDIRECT]: {};
  };
};

export type SignUpFlowMachineService = Interpreter<
  SignUpFlowContext,
  SignUpFlowStatesSchema,
  SignUpFlowEvents,
  {
    value: any;
    context: SignUpFlowContext;
  }
>;
